const Home = () => import('../pages/home').then(m => m.default || m)
const Trck = () => import('../pages/trck').then(m => m.default || m)

const Login = () => import('../pages/auth/login').then(m => m.default || m)
const PasswordReset = () => import('../pages/auth/password/reset').then(m => m.default || m)
const PasswordRequest = () => import('../pages/auth/password/email').then(m => m.default || m)

const Settings = () => import('../pages/settings/index').then(m => m.default || m)
const SettingsProfile = () => import('../pages/settings/profile').then(m => m.default || m)
const SettingsPassword = () => import('../pages/settings/password').then(m => m.default || m)
const SettingsSubscriptions = () => import('../pages/settings/subscriptions').then(m => m.default || m)
const SettingsFavourites = () => import('../pages/settings/favourites').then(m => m.default || m)

const SportsIndex = () => import('../pages/sports/index').then(m => m.default || m)
const SportsShow = () => import('../pages/sports/show').then(m => m.default || m)

const AlertsIndex = () => import('../pages/alerts/index').then(m => m.default || m)
const AlertsShow = () => import('../pages/alerts/show').then(m => m.default || m)

// const Fantasy = () => import('../pages/fantasy/index').then(m => m.default || m)
const EuroBasket = () => import('../pages/eurobasket/index').then(m => m.default || m)
const EuroLeague = () => import('../pages/euroleague/index').then(m => m.default || m)
const LnbProA = () => import('../pages/lnbproa/index').then(m => m.default || m)
const UnitelBasket = () => import('../pages/unitelbasket/index').then(m => m.default || m)
const NBA = () => import('../pages/nba/index').then(m => m.default || m)
const LigaEndesa = () => import('../pages/ligaendesa/index').then(m => m.default || m)
const Mundial = () => import ('../pages/mundial/index').then(m => m.default || m)
const FibaAfrica = () => import('../pages/fibaafrica/index').then(m => m.default || m)
const Widget = () => import('../pages/widget/index').then(m => m.default || m)
const Ligas = () => import('../pages/ligas/index').then(m => m.default || m)

const TEC = () => import('../pages/tec/index').then(m => m.default || m)
const Results = () => import('../pages/results/index').then(m => m.default || m)
const ContestShow = () => import('../pages/results/show').then(m => m.default || m)

const Regulation = () => import('../pages/regulation/index').then(m => m.default || m)
const ContactUs = () => import('../pages/contact/index').then(m => m.default || m)
const DiscontinuedIndex = () => import('../pages/discontinued/index').then(m => m.default || m)

export default [
    {path: '/', name: 'home', component: Home},
    {path: '/trck', name: 'trck', component: Trck},

    {path: '/login', name: 'login', component: Login},
    {path: '/password/reset', name: 'password.request', component: PasswordRequest},
    {path: '/password/reset/:token', name: 'password.reset', component: PasswordReset},

    {
        path: '/settings', component: Settings, children: [
            {path: '', redirect: {name: 'settings.profile'}},
            {path: 'password', name: 'settings.password', component: SettingsPassword},
        ]
    },

    {path: '/profile', name: 'profile', component: SettingsProfile},
    {path: '/subscriptions', name: 'subscriptions', component: SettingsSubscriptions},
    {path: '/favourites', name: 'favourites', component: SettingsFavourites},

    {path: '/alertas/', name: 'alerts.index', component: AlertsIndex},
    {path: '/alertas/:slug', name: 'alerts.show', component: AlertsShow},

    {path: '/desporto/', name: 'sports.index', component: SportsIndex},
    {path: '/desporto/by/:slug', name: 'sports.source', component: SportsIndex},
    {path: '/desporto/search/:query', name: 'sports.search', component: SportsIndex},
    {path: '/desporto/:slug', name: 'sports.show', component: SportsShow},

    // {path: '/fantasy', name: 'fantasy', component: Fantasy},
    // {path: '/eurobasket', name: 'eurobasket', component: EuroBasket},
    // {path: '/euroleague', name: 'euroleague', component: EuroLeague},
    // {path: '/lnbproa', name: 'lnbproa', component: LnbProA},
    // {path: '/ligaendesa', name: 'ligaendesa', component: LigaEndesa},
    // {path: '/nba', name: 'nba', component: NBA},
    // {path: '/all', name: 'widget', component: Widget},

    {path: '/liga/:slug', name: 'ligas', component: Ligas},

    {path: '/unitelbasket', name: 'unitelbasket', component: UnitelBasket},
    {path: '/nba', name: 'nba', component: NBA},
    {path: '/ligaendesa', name: 'ligaendesa', component: LigaEndesa},
    {path: '/mundial', name: 'mundial', component: Mundial},
    {path: '/fibaafrica', name: 'fibaafrica', component: FibaAfrica},
    {path: '/all', name: 'widget', component: Widget},


    {path: '/pages/tec', name: 'tec', component: TEC},
    {path: '/passatempos', name: 'contests', component: Results},
    {path: '/passatempos/:slug', name: 'contest.show', component: ContestShow},

    {path: '/pages/regulation', name: 'regulation', component: Regulation},
    {path: '/pages/contact', name: 'contact-us', component: ContactUs},

    {path: '*', name: '404', component: require('../pages/errors/404.vue')},

    { path: '/discontinued', name: 'Discontinued', component: DiscontinuedIndex },
]



// WEBPACK FOOTER //
// ./resources/assets/js/router/routes.js